import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

export const listingSlice = createSlice({
    name: "listing",
    initialState: {
        listingLimitExceedPopup: false
    },
    reducers: {
        toggleListingLimitExceedPopup: (state, action) => {
            if (action.payload !== 'undefined' && typeof action.payload === 'boolean') {
                state.listingLimitExceedPopup = action.payload
                return;
            }
            state.listingLimitExceedPopup = !state.listingLimitExceedPopup;
        }
    }
});

const listingReducer = listingSlice.reducer;
const listingSliceName = listingSlice.name;
const useListingStore = () => useSelector((state)=> state.listing);
export const { toggleListingLimitExceedPopup } = listingSlice.actions;

export {
    listingSliceName,
    listingReducer,
    useListingStore
};